module.exports = "https://ec-cstatic.akulaku.net/mall/mobile/_next/static/images/no_coupon-8e18a96156919ac02a963c9195b185d8.png";